import { FIELDS_GROUP_MAP } from "../../../../shared/config/fieldsGroup.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import { getConstructorFieldsValue } from "../../../../shared/store/config/lib/getConstructorFieldsValue.js";
import "@perxis-auto/shared";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import { selectPage } from "../../../../shared/store/installation/model/selectors/selectPage.js";
import "../../../../shared/store/installation/model/slice.js";
import "../../../../shared/store/installation/middleware/index.js";
const selectOptionGroupsParameters = createAppSelector(
  [selectSlice, selectPage],
  (config, page) => {
    const { spaceId, envId } = config;
    const constructorFieldsValue = getConstructorFieldsValue(
      config,
      FIELDS_GROUP_MAP.VEHICLE_EQUIPMENT_GET_OPTION_GROUPS,
      page.current
    );
    return {
      spaceId,
      envId,
      options: {
        options: {
          fields: constructorFieldsValue == null ? void 0 : constructorFieldsValue.fields
        }
      },
      referenceFields: constructorFieldsValue == null ? void 0 : constructorFieldsValue.referenceFields
    };
  }
);
export {
  selectOptionGroupsParameters
};
